<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M880.7 327.5v-.5c-1.4-6.7-4.7-12.8-9.5-17.2-5.2-4.8-11.5-7.3-18.2-7.3H699V262c0-49.8-19.6-96.6-55-132s-82.3-54.9-132-54.9-96.6 19.5-132 54.9-54.9 82.3-54.9 132v40.5H171c-13.1 0-24.8 10.3-27.6 24.5l-.1.2-45.5 591.6v2.4c0 16.3 11.4 27.7 27.7 27.7l773 .1c16.3 0 27.7-11.4 27.7-27.7v-2.5l-45.5-591.3zm-500-65.6c0-72.5 58.9-131.4 131.4-131.4s131.4 58.9 131.4 131.4v40.5H380.7v-40.5zM156.2 893.5l1.2-12.6 5.5-78.4h-.4l5.5-73.6 28-371.1h129v89.8c-13.5 8.2-22.7 24.9-22.7 41.6 0 27.9 22.7 50.5 50.5 50.5 27.9 0 50.5-22.7 50.5-50.5 0-16.7-9.2-33.4-22.7-41.6v-89.8h262.8v89.8c-13.5 8.2-22.7 24.9-22.7 41.6 0 27.9 22.6 50.5 50.5 50.5s50.5-22.7 50.5-50.5c0-16.7-9.2-33.4-22.7-41.6v-89.8h129l28.2 377.8v.2l12.2 140 1.8 17.8h-714z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="m868.5 809.8-1.8-17.8h-707l-2.3 22.9 5.6-78.4h698.2l-5-66.7z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
